export const MOBILE_FCM_TOKEN_KEY = 'mobile-fcm-token';
export const MOBILE_DEVICE_ID_KEY = 'mobile-device-id';
export const MOBILE_ORG_ID_KEY = 'mobile-org-id';
export const NAV_BAR_COLLAPSE_STATUS_KEY = 'navBarCollapseStatus';

export const LOCAL_STORAGE_BYPASS_LIST = [NAV_BAR_COLLAPSE_STATUS_KEY];
